module.exports = __webpack_public_path__ + "img/3.a3a821c0.png";